import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import { useTranslation } from 'react-i18next';
import { Organizational_Chart } from "../../components/ui/organizational_chart.js";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as api from "../../api/apiConnector.js";
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as utils from "../../components/utils.js";
import Undo_Redo from "../../components/ui/undo_redo.js";
import Choices from '../../components/Choices.js';

const Requirements_Flows_Screen = (params) => {
    const { currentUser } = useContext(UserContext);
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [requirements, setRequirements] = useState(null);
    const [businessUnits, setBusinessUnits] = useState(null);
    const [functionsVoc, setFunctionsVoc] = useState(null);
    const [currentNode, setCurrentNode] = useState(null);
    const [draggingNode, setDraggingNode] = useState(null);
    const [droppingNode, setDroppingNode] = useState(null);
    const [itemsToAdd, setItemsToAdd] = useState(null);
    const [preventQuit, setPreventQuit] = useState(false);

    let undo_redo = null;

    const _update = () => {
        setData(utils.clone(data));
        if (undo_redo) {
            undo_redo.push(data);
            setPreventQuit(true);
        }
        
    }

    const _row = (r) => {
        const _actors = (r.Actors ? r.Actors.map((a) => {
            return `${a.LastName} ${a.Name} (${a.FunctionName})`;
        }) : []).join(", ");

        return (<tr style={{ cursor: "pointer" }}>
            <th scole="row">{data.findIndex(x => x === r) + 1}</th>
            <td style={{ whiteSpace: "wrap" }}>{r.Requirement_Code} {r.Requirement_Name}</td>
            <td style={{ whiteSpace: "wrap" }}>{r.OrganizationalUnit_Code} {r.OrganizationalUnit_Name}</td>
            <td style={{ whiteSpace: "wrap" }}>
                {
                    _actors
                }
            </td>
            <td>
                <i style={{ cursor: 'pointer', color: '#17a2b8' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('edit', { ns: 'labels' })} onClick={(e) => {
                    setCurrentNode(utils.clone(r));
                }} className="fa-regular fa-pen-to-square me-4 fa-2x hover-icon-edit" />

                <i style={{ cursor: 'pointer', color: '#dc3545' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={t('delete', { ns: 'labels' })} onClick={(e) => {
                    r.Deleted = 1;
                    r.__toUpdate = true;
                    _update();
                }} className="fa fa-trash fa-2x hover-icon-trash me-4" />
            </td>
        </tr>)
    }

    const _rows = () => {
        return data.filter(x => !x.Deleted).map((r) => _row(r));
    }

    const _table = () => {
        return (<table className="table">
            <thead>
                <tr>
                    <th className="col-md-1" scope="col">#</th>
                    <th className="col-md-4">Requirement</th>
                    <th className="col-md-4">Context</th>
                    <th className="col-md-4">Actors</th>
                    <th className="col-md-1" scope="col"></th>
                </tr>
            </thead>
            <tbody id="tBodyTable">
                {_rows()}
            </tbody>
        </table>);
    }

    const _toAddModal = () => {
        if (itemsToAdd) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="items_to_add_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Items to add</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setItemsToAdd(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p>There are possible <strong>{itemsToAdd.length}</strong> child elements to add. Do you want to add them automatically?</p>

                                    <ol class="list-group list-group">
                                        {itemsToAdd.map((i) => {
                                            return (
                                                <li class="list-group-item d-flex justify-content-between align-items-start">
                                                    <div class="ms-2 me-auto">
                                                        <div class="fw-bold">{i.ra.Code} {i.ra.Name}</div>
                                                        <hr></hr>
                                                        {i.ba.Code} {i.ba.Name}
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ol>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={(e) => {
                                            setItemsToAdd(null);
                                        }}
                                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={async (e) => {
                                        for (const ia of itemsToAdd) {
                                            const _item = _getNew();
                                            _item.OrganizationalUnitId = ia.ba?.Id;
                                            _item.RequirementId = ia.ra.Id;
                                            _item.Requirement_Code = ia.ra.Code;
                                            _item.Requirement_Name = ia.ra.Name;
                                            _item.OrganizationalUnit_Code = ia.ba?.Code;
                                            _item.OrganizationalUnit_Name = ia.ba?.Name;
                                            _item.__toUpdate = true;
                                            data.push(_item);
                                        }

                                        setItemsToAdd(null);
                                        _update();
                                    }}
                                        className="btn btn-primary" disabled={_validate ? null : true}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }
    }

    const _editModal = () => {
        const _validate = () => {
            if (!currentNode.Name) return false;
            return true;
        }

        const _localUpdate = () => {
            currentNode.__localUpdate = true;
            setCurrentNode(utils.clone(currentNode));
        }

        const _confirmEdit = () => {
            const _indexToUpdate = data.findIndex(x => x.Id == currentNode.Id);
            currentNode.__toUpdate = true;
            currentNode.__localUpdate = false;
            data[_indexToUpdate] = currentNode;



            const _getC_getRequirements = (r) => {
                const output = [];
                output.push(r);

                const _children = requirements.filter(x => x.ParentId == r.Id);
                for (let c of _children) {
                    output.push(..._getC_getRequirements(c));
                }

                return output;
            }

            if (currentNode.OrganizationalUnitId && currentNode.RequirementId) {
                const _childRequirements = _getC_getRequirements(requirements.find(x => x.Id == currentNode.RequirementId))
                    .sort((a, b) => { return a.ItemOrder - b.ItemOrder });
                const _currentBusinessUnit = businessUnits.find(y => y.Id == currentNode.OrganizationalUnitId);
                const _businessUnitsSameType = businessUnits.filter(x => x.UnitTypeCode == _currentBusinessUnit.UnitTypeCode)
                    .sort((a, b) => { return a.Name.localeCompare(b.Name) });

                const _itemsToAdd = [];

                for (const ba of _businessUnitsSameType) {
                    for (const ra of _childRequirements) {
                        _itemsToAdd.push({
                            ba,
                            ra
                        });
                    }
                }

                setItemsToAdd(_itemsToAdd);
            }


            _update();
            setCurrentNode(null);
        }

        const _actor = (f) => {
            const _selected = currentNode.Actors ? currentNode.Actors.filter(x => x.FunctionCode == f.Code) : [];
            return (
                <div>
                    <label for={`item_function_${f.Code}`} className="form-label">{f.Name}</label>
                    {<Choices voc={_selected}
                        multiple={true}
                        dropDownParent={"edit_modal"}
                        value={"Id"} text={"Name"}
                        selected={_selected}
                        textDelegate={(item) => {
                            return `${item.LastName} ${item.Name}`
                        }}
                        onChange={(e) => {
                            currentNode.Actors = (currentNode.Actors ?? []).filter(x => x.FunctionCode != f.Code);
                            currentNode.Actors.push(...e.selected.map(x => {
                                return {
                                    Id: x.Id,
                                    Name: x.Name,
                                    LastName: x.LastName,
                                    FunctionCode: f.Code,
                                    FunctionName: f.Name
                                }
                            }));
                        }}
                        remoteSource={async ({ text }) => {
                            const result = await api.sendMessage("usersGroups/search", {
                                user: currentUser(),
                                body: {
                                    name: text,
                                    searchGroups: false
                                }
                            });

                            return result?.filtered?.users ?? [];
                        }}
                    ></Choices>}
                    <small>Insert here all the actors with the function: <strong>{f.Name}</strong>. Actors must be previously defined as <strong>users</strong>.
                    </small>
                    <hr></hr>
                </div>)
        }


        if (currentNode) {

            const _businessUnit = businessUnits.find(x => x.Id == currentNode.OrganizationalUnitId) ?
                [businessUnits.find(x => x.Id == currentNode.OrganizationalUnitId)] :
                [];

            const _requirements = requirements.find(x => x.Id == currentNode.RequirementId) ?
                [requirements.find(x => x.Id == currentNode.RequirementId)] :
                [];

            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentNode.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label">Code</label>
                                        <input id="item_code" type="text" className="form-control" value={currentNode.Code}
                                            onChange={(e) => {
                                                currentNode.Code = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('nameOfItem', { ns: 'labels' })} />
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_requirement" className="form-label">Requirement<span className="text-danger">*</span></label>
                                        {<Choices voc={requirements}
                                            dropDownParent={"edit_modal"}
                                            value={"Id"} text={"Name"}
                                            selected={_requirements}
                                            textDelegate={(item) => {
                                                return `${item.Code} ${item.Name}`
                                            }}
                                            onChange={(e) => {
                                                const _selected = e.selected &&
                                                    e.selected.length > 0 ? e.selected[0] : null;

                                                if (_selected) {
                                                    currentNode.RequirementId = _selected.Id;
                                                    currentNode.Requirement_Code = _selected.Code;
                                                    currentNode.Requirement_Name = _selected.Name;

                                                }

                                                _localUpdate();
                                            }
                                            }></Choices>}
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_context" className="form-label">Context<span className="text-danger">*</span></label>
                                        {<Choices voc={businessUnits}
                                            dropDownParent={"edit_modal"}
                                            value={"Id"} text={"Name"}
                                            textDelegate={(item) => {
                                                return `${item.Code ?? ""} (${item.UnitType_Name}) ${item.Name} `
                                            }}
                                            selected={_businessUnit}
                                            onChange={(e) => {
                                                const _selected = e.selected &&
                                                    e.selected.length > 0 ? e.selected[0] : null;

                                                if (_selected) {
                                                    currentNode.OrganizationalUnitId = _selected.Id;
                                                    currentNode.OrganizationalUnit_Code = _selected.Code;
                                                    currentNode.OrganizationalUnit_Name = _selected.Name;

                                                }

                                                _localUpdate();
                                            }
                                            }></Choices>}
                                    </div>
                                    <br></br>
                                    <h5>Actors</h5>
                                    <div style={{
                                        padding: 15
                                    }}>

                                        {functionsVoc.map((v) => {
                                            return _actor(v);
                                        })}

                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_description" className="form-label">Description</label>
                                        <textarea id="item_description" rows="5" className="form-control" value={currentNode.Description}
                                            onChange={(e) => {
                                                currentNode.Description = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('descriptionOfItem', { ns: 'labels' })}>

                                        </textarea>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_notes" className="form-label">Notes</label>
                                        <textarea id="item_notes" rows="5" className="form-control" value={currentNode.Notes}
                                            onChange={(e) => {
                                                currentNode.Notes = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('notes', { ns: 'labels' })}>

                                        </textarea>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {
                                        _confirmEdit();
                                    }}
                                        className="btn btn-primary" disabled={_validate ? null : true}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }

    }

    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: "Home"
        },
        {
            link: "/Requirements",
            name: "Requirements"
        },
        {
            link: "/Requirements/Flows",
            name: "Flows"
        }
        ];
        breadcrumb.set(path);
    }


    const retrieveData = async () => {
        const result = (await api.sendMessage("admin/requirements/flows/get_all", {
            user: currentUser(),
        }));

        if (!result.success) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: `There was an error accessing to the requested data: ${result?.message}`,
                allowOutsideClick: false
            });
            return;
        }

        const requirements = ((await api.sendMessage("admin/requirements/get_all", {
            user: currentUser(),
        }))?.requirements ?? []).sort((a, b) => { return `${a.Code} ${a.Name}`.localeCompare(`${b.Code} ${b.Name}`) });

        const units = (await api.sendMessage("admin/system/organization/get_business_units", {
            user: currentUser(),
        }))?.units ?? [];

        var functionsVoc = (await api.sendMessage("admin/vocs/get", {
            user: currentUser(),
            body: {
                voc_id: "functional_chart_roles"
            }
        }))?.items ?? [];

        setData(result.flows);
        setRequirements(requirements);
        setBusinessUnits(units);
        setFunctionsVoc(functionsVoc);
        undo_redo.push(result.flows);
    }

    useEffect(() => {
        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();
        })();
    }, []);


    useEffect(() => {
        if (preventQuit) {
            const handleBeforeUnload = (event) => {

                event.preventDefault();

                event.returnValue = '';
            };

            window.addEventListener('beforeunload', handleBeforeUnload);

            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [preventQuit]);


    const _toSave = () => {
        return data.filter(x => x.__toUpdate);
    }

    const _validate = () => {
        const errors = [];

        for (const d of data) {
            if (!d.RequirementId) {
                var error = `The requirement is missing for the item # ${data.findIndex(x => x === d) + 1}`
                errors.push(error);
            }



            if (!d.Actors || d.Actors.length == 0) {
                var error = `The functional roles are missing for the item # ${data.findIndex(x => x === d) + 1}`
                errors.push(error);
            }
        }

        return errors;
    }

    const _save = async () => {
        const errors = _validate();

        withReactContent(Swal).fire({
                                title: t('saving', { ns: 'labels' }),
                    icon: "info",
            text: "Saving data",
            allowOutsideClick: false
        });

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: "ERROR",
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true
            });
        }
        else {
            const dataToUpdate = _toSave();

            if (dataToUpdate.length == 0) {
                withReactContent(Swal).fire({
                    title: "Data just updated",
                    icon: "info",
                    text: "There are no changes after the last save",
                    showConfirmButton: true
                });
                return { success: false };
            }

            const result = await api.sendMessage("admin/requirements/flows/save", {
                user: currentUser(),
                body: {
                    flows: dataToUpdate
                }

            });

            if (result.success) {
                withReactContent(Swal).fire({
                    title: "Success",
                    icon: "success",
                    text: `${dataToUpdate.length} requirements saved with success`,
                    showConfirmButton: true
                });

                for (const d of data) {
                    d.__toUpdate = false;
                    setData(utils.clone(data));
                }

                return result;
            }
            else {
                withReactContent(Swal).fire({
                    title: "ERROR",
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });

                return result;
            }
        }

    }

    const _getNew = async () => {
        const _link = (await api.sendMessage("admin/system/organization/get_new_user_connection", {
            user: currentUser()
        }))?.link;


        return _link;
    }


    const _add_new = async () => {
        const _link = await _getNew();
        _link.__toUpdate = true;
        data.push(_link);
        _update();
        setCurrentNode(utils.clone(_link));
    }



    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>
                    <Undo_Redo onInit={(r) => {
                        undo_redo = r;
                    }}
                        onChange={(d) => {
                            setData(d);
                        }}
                    ></Undo_Redo>
                    <a className="text-primary me-2 fs-13" onClick={async (e) => {
                        _add_new();
                    }} role="button" title="Join a meet"><i className="fa-solid fa-plus fa-2x"></i>
                    </a>
                    <a className="text-primary fs-13" onClick={(e) => {
                        _save();
                    }} role="button" title="Save data"><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {data ? (<>
                                        {_editModal()}
                                        {_toAddModal()}
                                        {_table()}
                                    </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Requirements_Flows_Screen }
